import $ from "jquery";
import debug from 'bows/dist/bows.min.js';
import fitvid from "./base/_fitvid";
import isTouch from "./base/_isTouch";

const log = debug("YouTube");

window.wdg_youtube = {
	videoArray: [],
	videoCount: 0,
	videos: '',

};

function addAPI() {
	log('addAPI')
	var tag = document.createElement('script'),
		firstScriptTag = document.getElementsByTagName('script')[0];

	tag.src = "https://www.youtube.com/iframe_api";
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function init() {
	//this.videos = document.getElementsByClassName('video');
	wdg_youtube.videos = $('[data-yt]');

	if (wdg_youtube.videos.length > 0) {
		addAPI();
	}
}

function onPlayerStateChange(event) {
	// Get Video Title
	//console.log(event.target.B.videoData.title);
	if (event.data === -1) {
		//unstarted

	} else if (event.data === 0) {
		//ended

	} else if (event.data === 2) {
		//paused
	} else if (event.data === 3) {
		//buffering
	} else if (event.data === 5) {
		//video cued

	}
}
window.wdg_youtube_pauseVideos = function () {
	if (!isTouch.is_touch_device()) {
		let YTW = $('.video__player--yt');
		if (YTW.length) {
			YTW.each(function () {

				let YT = $(this).data('yta').split('player'),
					whichP = YT[1];

				wdg_youtube.videoArray[whichP].pauseVideo();
			});
		}

	}

}

function onPlayerReady() {


	$('.youtube-feature__button').addClass('youtube-feature__button--active').on('click', function (event) {
		let $this = $(this);
		let $yf = $this.closest('.youtube-feature');
		let YT = $this.next('.video__player--yt').data('yta').split('player');
		let which = YT[1];

		$this.addClass('youtube-feature__button--activated');
		$yf.find('.youtube-feature__flex').addClass('youtube-feature__flex--active');
		$yf.find('.youtube-feature__shadow').addClass('youtube-feature__shadow--active');
		if (!isTouch.is_touch_device()) {
			wdg_youtube_pauseVideos();
			wdg_youtube.videoArray[which].setVolume(20);
			wdg_youtube.videoArray[which].playVideo();
		}
	});
	fitvid();
}


window.onYouTubeIframeAPIReady = function () {
	wdg_youtube.videos.each(function () {
		var video = $(this),
			vidPlay = video.data('yt'),
			vidID;

		log(vidPlay);

		let splitWatch = vidPlay.split('v=');
		let splitSlash = vidPlay.split('/');
		if (splitWatch.length === 2) {
			let splitWatchParam = splitWatch[1].split('&');
			vidID = splitWatchParam[0];
		} else if (splitSlash.length > 1) {
			let splitSlashParam = splitSlash.pop().split('?');
			vidID = splitSlashParam[0];

		} else {
			vidID = vidPlay;
		}
		log(`vidID = ${vidID}`)
		var playerName = 'player' + wdg_youtube.videoCount;
		video.attr('data-YTA', playerName);

		video.append(`<div id="${playerName}" class="video-player" />`);

		let player_video = new YT.Player(playerName, {
			height: '529',
			width: '940',
			videoId: vidID,
			playerVars: {
				rel: 0,
				loop: 1,
				html5: 1
			},
			events: {
				'onStateChange': onPlayerStateChange,
				'onReady': onPlayerReady
			}
		});
		wdg_youtube.videoArray.push(player_video);
		wdg_youtube.videoCount++;
	});

	$('body').addClass('yt-ready');
}

export default {
	init: init
};
